import * as React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { tipoDni } from '../../constants/FieldsConst';
import { validFielddHelper } from '../../helpers/ValidFieldsHelper';

export const tiposDniEnums = [
  { id: 'V', text: 'VENEZOLANO' },
  { id: 'P', text: 'PASAPORTE' },
];

export const getTipoDniEnums = {
  V: 'VENEZOLANO',
  P: 'PASAPORTE',
};

const TiposDniField = ({
  onChange,
  required,
  value,
  helperText,
  error,
  disabled = false,
}) => {
  const xName = 'Tipo de DNI';

  const xSelect = (
    <FormControl fullWidth error={error} size="small" required>
      <InputLabel id={tipoDni}>{xName}</InputLabel>
      <Select
        labelId={tipoDni}
        id={tipoDni}
        required={required}
        disabled={disabled}
        value={value}
        label={xName}
        onChange={onChange}
      >
        {tiposDniEnums.map((item) => {
          return (
            <MenuItem key={item.id} value={item.id}>
              {item.text}
            </MenuItem>
          );
        })}
      </Select>
      {error && (
        <FormHelperText>
          {helperText ?? error ? validFielddHelper(1) : null}
        </FormHelperText>
      )}
    </FormControl>
  );

  return xSelect;
};

TiposDniField.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default TiposDniField;
